import {
  mergeLocaleData,
  sharedLocaleData,
} from '@b-stock/fe-core/bstock-next/locale'
import { payUiEnLocaleData } from '@b-stock/fe-core/pay-ui'

// Precompiled (flattened) map of the per-module locale JSON under translations/en/.
// Generated + gitignored; regenerated automatically on dev/build/lint/test. Keys
// are already dot-flattened; mergeLocaleData passes already-dotted keys through
// untouched while it flattens the nested shims below.
import precompiledEn from './translations/en.flattened.generated'
// Runtime shim spread under `Listings.` — Listings/other.json's keys are spread
// at the Listings level (e.g. `Listings.results`) with no `other.` segment, which
// the filename-based generator cannot produce.
import listingsOther from './translations/listings-other.en.json'
// Runtime shim spread at the message-ID ROOT (e.g. `AuctionList.allAuctions`) —
// unsorted.json's keys have no filename prefix, so they stay here and flatten at
// runtime. See scripts/locale-roots.js.
import unsortedEn from './translations/unsorted.en.json'

export const localeData = mergeLocaleData({
  en: {
    ...sharedLocaleData.en,
    ...payUiEnLocaleData,
    // Order mirrors the removed barrel: unsorted spread first, then the named
    // (precompiled) files win on any key collision.
    ...unsortedEn,
    Listings: listingsOther,
    ...precompiledEn,
  },
})
